import { Translatable } from '@fmnts/api/shared';
import { IFieldCondition } from '../api-model/condition';
import { FormField } from './form-field';

interface IFormFieldset {
  key: string;
  fields: FormField[];
  label?: Translatable<string> | string;
  condition?: IFieldCondition;
}

export class FormFieldset {
  key: string;
  fields: FormField[];
  label: Translatable<string> | string;
  condition?: IFieldCondition;

  constructor(obj: Readonly<IFormFieldset>) {
    this.key = obj.key;
    this.fields = obj.fields;
    this.label = obj.label || '';
    this.condition = obj.condition;
  }
}
